import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.TaskPage.components.MessagesTab.title',
    defaultMessage: 'Messages',
  },
})
